import { render, staticRenderFns } from "./TeacherView.vue?vue&type=template&id=20258f34&"
import script from "./TeacherView.vue?vue&type=script&lang=js&"
export * from "./TeacherView.vue?vue&type=script&lang=js&"
import style0 from "./TeacherView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports